import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'qt-badge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="qt-badge"
      [attr.data-position]="position"
      [attr.data-status]="badgeText">
      {{ badgeText }}
    </div>
  `,
  styles: [
    `
      .qt-badge {
        font-size: 11px;
        font-weight: 600;
        padding: 0px 7px;
        border-radius: 999px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
        background-color: #023e8a;
        color: white;
        white-space: nowrap;
        transform-origin: top right;
        user-select: none;
        text-transform: capitalize;

        &[data-position='top-right'] {
          transform: translate(-50%, 50%);
        }

        &[data-position='top-left'] {
          transform: translate(50%, 50%);
        }

        &[data-position='bottom-right'] {
          transform: translate(50%, 50%);
        }

        &[data-position='bottom-left'] {
          transform: translate(-50%, 50%);
        }

        &[data-status='alpha'] {
          background-color: #3a7f50;
        }

        &[data-status='beta'] {
          background-color: #3ba6c5;
        }

        &[data-status='new'] {
          background-color: #bc8517;
        }
      }
    `,
  ],
})
export class QtBadgeComponent {
  @Input() badgeText: string | undefined;
  @Input() position: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' =
    'top-right';
}
